import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteArticleByIds } from "../services/articles.service";
import { updateMainAndAlternativeProducts } from "./useDeleteArticles.helper";

export const useDeleteArticlesByIds = (mediaId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (articleIds: string[]) => {
      await updateMainAndAlternativeProducts(mediaId, articleIds);
      while (articleIds.length > 0) {
        await deleteArticleByIds(articleIds.splice(0, 50), queryClient);
      }
    },
  });
};
